import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { CasinoRequestFormatter } from "../CasinoRequestFormatter";
import { CasinoResponseFormatter } from "../CasinoResponseFormatter";
export function createCasinoConnection() {
    return createRESTConn({
        name: ConnectionNames.casino,
        handlers: {
            requestFormatter: CasinoRequestFormatter,
            responseFormatter: CasinoResponseFormatter
        }
    });
}
//# sourceMappingURL=CreateCasinoConnection.js.map